document.addEventListener('DOMContentLoaded', () => {

  /*
   * AIRCRAFTTAG MOTION SYSTEM
   * Homepage only
   * Hero is intentionally excluded.
   */

  const isHome =
    document.body.classList.contains('template-index') ||
    window.location.pathname === '/';

  if (!isHome) return;
/* =========================================================
   FIND YOUR AIRCRAFT — ANCHOR SCROLL
   ========================================================= */

if (window.location.hash === '#aircraft-finder') {
  setTimeout(() => {
    const finder = document.getElementById('aircraft-finder');

    if (finder) {
      const header = document.querySelector(
        '.shopify-section-header-sticky, .section-header, header'
      );

      const headerHeight = header ? header.offsetHeight : 0;

      const targetPosition =
        finder.getBoundingClientRect().top +
        window.scrollY -
        headerHeight -
        20;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }, 500);
}

  /* =====================================================
     AUTOMATIC ELEMENT SETUP
     ===================================================== */

  const revealSelectors = [
    '.faa-eyebrow',
    '.faa-heading',
    '.faa-intro',

    '.ac-eyebrow',
    '.ac-heading',
    '.ac-subheading',
    '.ac-footer',

    '.stc-heading',
    '.stc-subheading',

    '[id^="made-from-the-real-thing"] h2',
    '[id^="made-from-the-real-thing"] p',

    '#shopify-section-template--30543431663943__featured_collection_FtxqrM .title',
    '#shopify-section-template--30543431663943__featured_collection_FtxqrM .collection__description',
    '#shopify-section-template--30543431663943__featured_collection_FtxqrM .collection__view-all'
  ];

  revealSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add('at-reveal');
    });
  });


  /* =====================================================
     PROCESS SECTION
     ===================================================== */

  document
    .querySelectorAll('[id^="from-aircraft-"] .faa-hero')
    .forEach(el => {
      el.classList.add('at-image-reveal');
    });

  document
    .querySelectorAll('[id^="from-aircraft-"] .faa-card')
    .forEach((el, index) => {
      el.classList.add(
        'at-image-reveal',
        'at-hover-image',
        `at-delay-${Math.min(index + 1, 5)}`
      );
    });


  /* =====================================================
     AVIATION COMMUNITY
     ===================================================== */

  document
    .querySelectorAll('[id^="aviation-community-"] .ac-card')
    .forEach((el, index) => {
      el.classList.add(
        'at-image-reveal',
        'at-hover-image',
        `at-delay-${Math.min(index + 1, 5)}`
      );
    });


  /* =====================================================
     SHOP THE COLLECTION
     ===================================================== */

  document
    .querySelectorAll('.stc-card')
    .forEach((el, index) => {
      el.classList.add(
        'at-image-reveal',
        'at-hover-image',
        `at-delay-${Math.min(index + 1, 5)}`
      );
    });


  /* =====================================================
     MOST WANTED PRODUCTS
     ===================================================== */

  document
    .querySelectorAll(
      '#shopify-section-template--30543431663943__featured_collection_FtxqrM .grid__item'
    )
    .forEach((el, index) => {
      el.classList.add(
        'at-reveal',
        `at-delay-${Math.min(index + 1, 5)}`
      );
    });


  /* =====================================================
     BUTTON MICRO INTERACTIONS
     ===================================================== */

  document
    .querySelectorAll(
      '.button, .ac-link, .stc-link'
    )
    .forEach(el => {

      /*
       * Exclude the hero buttons.
       */
      if (!el.closest(
        '#Banner-template--30543431663943__image_banner_QJGPMC'
      )) {
        el.classList.add('at-motion-button');
      }

    });


  /* =====================================================
     INTERSECTION OBSERVER
     ===================================================== */

  const animatedElements = document.querySelectorAll(
    '.at-reveal, .at-image-reveal'
  );

  if (!('IntersectionObserver' in window)) {

    animatedElements.forEach(el => {
      el.classList.add('at-visible');
    });

  } else {

    const observer = new IntersectionObserver(
      entries => {

        entries.forEach(entry => {

          if (entry.isIntersecting) {

            entry.target.classList.add('at-visible');

            /*
             * Animate once only.
             */
            observer.unobserve(entry.target);

          }

        });

      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -6% 0px'
      }
    );

    animatedElements.forEach(el => {
      observer.observe(el);
    });

  }


  /* =====================================================
     SUBTLE DESKTOP PARALLAX
     FROM AIRCRAFT TO AIRCRAFTTAG
     ===================================================== */

  const parallaxAllowed =
    window.matchMedia('(min-width: 990px)').matches &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (parallaxAllowed) {

    const parallaxImages = document.querySelectorAll(
      '[id^="from-aircraft-"] .faa-hero img'
    );

    let ticking = false;

    const updateParallax = () => {

      const viewportHeight = window.innerHeight;

      parallaxImages.forEach(image => {

        const container = image.closest('.faa-hero');

        if (!container) return;

        const rect = container.getBoundingClientRect();

        /*
         * Skip elements outside the viewport.
         */
        if (
          rect.bottom < 0 ||
          rect.top > viewportHeight
        ) {
          return;
        }

        const progress =
          (viewportHeight - rect.top) /
          (viewportHeight + rect.height);

        /*
         * Premium, subtle movement.
         */
        const movement =
          (progress - 0.5) * 70;

        image.style.transform =
          `scale(1.10) translate3d(0, ${movement}px, 0)`;

      });

      ticking = false;

    };

    const requestParallax = () => {

      if (!ticking) {

        window.requestAnimationFrame(updateParallax);

        ticking = true;

      }

    };

    window.addEventListener(
      'scroll',
      requestParallax,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      requestParallax
    );

    /*
     * Initial position.
     */
    requestParallax();

  }

  /* =====================================================
   SHOP THE COLLECTION — MOBILE PARALLAX
   ===================================================== */

if (
  window.matchMedia('(max-width: 749px)').matches &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches
) {

  const stcCards = document.querySelectorAll('.stc-card');

  let stcTicking = false;

  const updateStcParallax = () => {

    const viewportHeight = window.innerHeight;

    stcCards.forEach(card => {

      const image = card.querySelector('img');
      if (!image) return;

      const rect = card.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > viewportHeight) {
        return;
      }

      const cardCenter = rect.top + rect.height / 2;
      const viewportCenter = viewportHeight / 2;

      const progress =
        (cardCenter - viewportCenter) /
        viewportHeight;

      const movement = progress * -60;

      image.style.transform =
        `translate3d(0, ${movement}px, 0) scale(1.12)`;

    });

    stcTicking = false;
  };

  const requestStcParallax = () => {
    if (!stcTicking) {
      requestAnimationFrame(updateStcParallax);
      stcTicking = true;
    }
  };

  window.addEventListener(
    'scroll',
    requestStcParallax,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    requestStcParallax
  );

  requestStcParallax();
}
});
/* =========================================================
   AIRCRAFTTAG — FIND YOUR AIRCRAFT ANCHOR
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  function scrollToAircraftFinder() {
    if (window.location.hash !== '#aircraft-finder') return;

    const finder = document.getElementById('aircraft-finder');
    if (!finder) return;

    setTimeout(function () {
      const header = document.querySelector(
        '.shopify-section-header-sticky, .section-header, header'
      );

      const headerHeight = header ? header.offsetHeight : 0;

      const targetPosition =
        finder.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        20;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }, 300);
  }

  scrollToAircraftFinder();

  window.addEventListener('hashchange', scrollToAircraftFinder);

});